import '../assets/NcFilePicker-BjFpDu4R.css';
import { defineComponent, ref, computed, nextTick } from "vue";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
import { N as NcActionButton } from "./NcActionButton-D7uypboC.mjs";
import NcActionCaption from "../Components/NcActionCaption.mjs";
import { N as NcActions } from "./NcActions-CX1MSord.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-Bui9PhAS.mjs";
import NcLoadingIcon from "../Components/NcLoadingIcon.mjs";
import { r as register, M as t41, a as t } from "./_l10n-CAnZaLWU.mjs";
const _sfc_main$3 = {
  name: "FolderUploadIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var _sfc_render$3 = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("span", _vm._b({ staticClass: "material-design-icon folder-upload-icon", attrs: { "aria-hidden": _vm.title ? null : "true", "aria-label": _vm.title, "role": "img" }, on: { "click": function($event) {
    return _vm.$emit("click", $event);
  } } }, "span", _vm.$attrs, false), [_c("svg", { staticClass: "material-design-icon__svg", attrs: { "fill": _vm.fillColor, "width": _vm.size, "height": _vm.size, "viewBox": "0 0 24 24" } }, [_c("path", { attrs: { "d": "M20,6A2,2 0 0,1 22,8V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H10L12,6H20M10.75,13H14V17H16V13H19.25L15,8.75" } }, [_vm.title ? _c("title", [_vm._v(_vm._s(_vm.title))]) : _vm._e()])])]);
};
var _sfc_staticRenderFns$3 = [];
var __component__$3 = /* @__PURE__ */ normalizeComponent(
  _sfc_main$3,
  _sfc_render$3,
  _sfc_staticRenderFns$3,
  false,
  null,
  null
);
const IconFolderUpload = __component__$3.exports;
const _sfc_main$2 = {
  name: "PlusIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var _sfc_render$2 = function render2() {
  var _vm = this, _c = _vm._self._c;
  return _c("span", _vm._b({ staticClass: "material-design-icon plus-icon", attrs: { "aria-hidden": _vm.title ? null : "true", "aria-label": _vm.title, "role": "img" }, on: { "click": function($event) {
    return _vm.$emit("click", $event);
  } } }, "span", _vm.$attrs, false), [_c("svg", { staticClass: "material-design-icon__svg", attrs: { "fill": _vm.fillColor, "width": _vm.size, "height": _vm.size, "viewBox": "0 0 24 24" } }, [_c("path", { attrs: { "d": "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" } }, [_vm.title ? _c("title", [_vm._v(_vm._s(_vm.title))]) : _vm._e()])])]);
};
var _sfc_staticRenderFns$2 = [];
var __component__$2 = /* @__PURE__ */ normalizeComponent(
  _sfc_main$2,
  _sfc_render$2,
  _sfc_staticRenderFns$2,
  false,
  null,
  null
);
const IconPlus = __component__$2.exports;
const _sfc_main$1 = {
  name: "UploadIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var _sfc_render$1 = function render3() {
  var _vm = this, _c = _vm._self._c;
  return _c("span", _vm._b({ staticClass: "material-design-icon upload-icon", attrs: { "aria-hidden": _vm.title ? null : "true", "aria-label": _vm.title, "role": "img" }, on: { "click": function($event) {
    return _vm.$emit("click", $event);
  } } }, "span", _vm.$attrs, false), [_c("svg", { staticClass: "material-design-icon__svg", attrs: { "fill": _vm.fillColor, "width": _vm.size, "height": _vm.size, "viewBox": "0 0 24 24" } }, [_c("path", { attrs: { "d": "M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z" } }, [_vm.title ? _c("title", [_vm._v(_vm._s(_vm.title))]) : _vm._e()])])]);
};
var _sfc_staticRenderFns$1 = [];
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  _sfc_main$1,
  _sfc_render$1,
  _sfc_staticRenderFns$1,
  false,
  null,
  null
);
const IconUpload = __component__$1.exports;
register(t41);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcFilePicker",
  props: {
    accept: { default: void 0 },
    actionCaption: { default: "" },
    actions: { default: () => [] },
    directory: { type: Boolean },
    directoryOnly: { type: Boolean },
    disabled: { type: Boolean },
    iconOnly: { type: Boolean },
    label: { default: void 0 },
    loading: { type: Boolean },
    multiple: { type: Boolean },
    variant: { default: "primary" }
  },
  emits: ["pick"],
  setup(__props, { expose, emit }) {
    const props = __props;
    expose({
      reset
    });
    const formElement = ref(null);
    const inputElement = ref(null);
    const currentLabel = computed(() => {
      if (props.loading) {
        return t("Uploading …");
      } else if (props.label) {
        return props.label;
      } else if (props.directoryOnly) {
        return t("Pick folder");
      }
      return props.multiple ? t("Pick files") : t("Pick file");
    });
    const canUploadFolders = computed(() => {
      return (props.directory || props.directoryOnly) && "webkitdirectory" in HTMLInputElement.prototype;
    });
    function triggerPickFiles(uploadFolders) {
      reset();
      if (canUploadFolders.value) {
        inputElement.value.webkitdirectory = uploadFolders;
      }
      nextTick(() => inputElement.value.click());
    }
    function onPick() {
      const files = inputElement.value?.files ? Array.from(inputElement.value.files) : [];
      emit("pick", files);
    }
    function reset() {
      formElement.value.reset();
    }
    return { __sfc: true, props, emit, formElement, inputElement, currentLabel, canUploadFolders, triggerPickFiles, onPick, reset, IconFolderUpload, IconPlus, IconUpload, NcActionButton, NcActionCaption, NcActions, NcIconSvgWrapper, NcLoadingIcon, t };
  }
});
const filePicker = "_filePicker_2NMRS";
const style0 = {
  filePicker
};
var _sfc_render = function render4() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("form", { ref: "formElement", class: _vm.$style.filePicker }, [_c(_setup.NcActions, { attrs: { "aria-label": _setup.currentLabel, "disabled": _vm.disabled || _vm.loading, "menu-name": _vm.iconOnly ? void 0 : _setup.currentLabel, "force-name": !_vm.iconOnly, "variant": _vm.variant }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
    return [!_vm.loading ? _vm._t("icon", function() {
      return [_c(_setup.IconPlus, { attrs: { "size": 20 } })];
    }) : _c(_setup.NcLoadingIcon)];
  }, proxy: true }], null, true) }, [_vm.actionCaption ? _c(_setup.NcActionCaption, { attrs: { "name": _vm.actionCaption } }) : _vm._e(), !_vm.directoryOnly ? _c(_setup.NcActionButton, { attrs: { "close-after-click": "" }, on: { "click": function($event) {
    return _setup.triggerPickFiles(false);
  } }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
    return [_c(_setup.IconUpload, { attrs: { "size": 20 } })];
  }, proxy: true }], null, false, 3377047136) }, [_vm._v(" " + _vm._s(_setup.canUploadFolders || !!_vm.$slots.actions ? _vm.multiple ? _setup.t("Upload files") : _setup.t("Upload file") : _setup.currentLabel) + " ")]) : _vm._e(), _setup.canUploadFolders ? _c(_setup.NcActionButton, { attrs: { "close-after-click": "" }, on: { "click": function($event) {
    return _setup.triggerPickFiles(true);
  } }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
    return [_c(_setup.IconFolderUpload, { staticStyle: { "color": "var(--color-primary-element)" }, attrs: { "size": 20 } })];
  }, proxy: true }], null, false, 746052933) }, [_vm._v(" " + _vm._s(!_vm.directoryOnly || !!_vm.$slots.actions ? _setup.t("Upload folder") : _setup.currentLabel) + " ")]) : _vm._e(), _vm._l(_vm.actions, function(group) {
    return [group.caption ? _c(_setup.NcActionCaption, { key: group.caption, attrs: { "name": group.caption } }) : _vm._e(), _vm._l(group.actions ?? [group], function(action) {
      return _c(_setup.NcActionButton, { key: action.label, attrs: { "close-after-click": "" }, on: { "click": action.onClick }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
        return [_c(_setup.NcIconSvgWrapper, { attrs: { "svg": action.iconSvg } })];
      }, proxy: true }], null, true) }, [_vm._v(" " + _vm._s(action.label) + " ")]);
    })];
  })], 2), _c("input", { ref: "inputElement", staticClass: "hidden-visually", attrs: { "accept": _vm.accept?.join(", "), "aria-hidden": "true", "multiple": _vm.multiple, "type": "file" }, on: { "change": _setup.onPick } }), _vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcFilePicker = __component__.exports;
export {
  NcFilePicker as N
};
//# sourceMappingURL=NcFilePicker-Dg6UqMN1.mjs.map
